'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AUIApplicationLogo = require('./AUIApplicationLogo');

var _AUIApplicationLogo2 = _interopRequireDefault(_AUIApplicationLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIApplicationHeader = function AUIApplicationHeader(_ref) {
    var logo = _ref.logo,
        headerLink = _ref.headerLink,
        primaryContent = _ref.primaryContent,
        secondaryContent = _ref.secondaryContent,
        text = _ref.text;
    return _react2.default.createElement(
        'header',
        { id: 'header', role: 'banner' },
        _react2.default.createElement(
            'nav',
            { className: 'aui-header aui-dropdown2-trigger-group', 'data-aui-response': 'true', role: 'navigation' },
            _react2.default.createElement(
                'div',
                { className: 'aui-header-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'aui-header-primary' },
                    _react2.default.createElement(_AUIApplicationLogo2.default, { logo: logo, text: text, headerLink: headerLink ? headerLink : '/' }),
                    primaryContent
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'aui-header-secondary' },
                    secondaryContent
                )
            )
        )
    );
};

AUIApplicationHeader.displayName = 'AUIApplicationHeader';
AUIApplicationHeader.propTypes = {
    logo: _propTypes2.default.oneOf(['aui', 'bamboo', 'bitbucket', 'confluence', 'crowd', 'fecru', 'hipchat', 'jira', 'stash']).isRequired,
    headerLink: _propTypes2.default.string,
    primaryContent: _propTypes2.default.node,
    secondaryContent: _propTypes2.default.string,
    text: _propTypes2.default.string
};

exports.default = AUIApplicationHeader;
//# sourceMappingURL=AUIApplicationHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIApplicationHeader.js
// module id = 169
// module chunks = 0